import { useQuery } from '@tanstack/react-query';

import { TEAM_LEAGUE_BALL_SELECTION_QUERY_KEY } from '@/hooks/constants';
import { getSystemLocationBalls } from '@/infrastructure/network/data/system-location-balls/get-system-location-balls';
import { useOrganizationStore } from '@/store/organization-store';

export const useBallSelectionQuery = (enabled = true) => {
	const store = useOrganizationStore();

	return useQuery({
		queryKey: [TEAM_LEAGUE_BALL_SELECTION_QUERY_KEY, store.teamLeagueUuid],
		queryFn: () => getSystemLocationBalls({ teamLeagueUuid: store.teamLeagueUuid }),
		enabled: enabled && !!store.teamLeagueUuid
	});
};
